import {cn} from "@/lib/utils";
import React from "react";
import logo from '@assets/images/logo/logo-sm.png'
import Icon from "@/components/Icon";
import {useMenu} from "@/context/MenuContext";

export function TopMenuAdmin({className, ...props}) {
    const {isOpen, onMenuOpen, onMenuClose} = useMenu();

    const onNavbarClick = (event) => {
        if(!event.target.tagName === 'svg' && !event.target.tagName === 'path') {
            onMenuClose();
        }
    }

    return (
        <>
            <nav className={cn("flex items-center space-x-4 lg:space-x-6", className)} {...props} onClick={(event) => {onNavbarClick(event)}}>
                <a href={'/'} className={'hidden md:block lg:block'}>
                    <img
                        src={logo}
                        className='h-10 cursor-pointer m-10'
                        alt='Logo'
                        // onClick={() => {
                        //     navigate('/');
                        // }}
                    />
                </a>
                {
                    // (location.pathname !== '/' &&  (isAdminMenu && isInstAdmin)) &&
                    <div className={'cursor-pointer'} onClick={() => {
                        isOpen ? onMenuClose() : onMenuOpen()
                    }}>
                        <div>{isOpen ? <Icon name={'X'} size={24}/> : <Icon name={'Menu'} size={24}/>}</div>
                    </div>
                }
                {/*<Link to={"/"}*/}
                {/*      className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/') ? ' text-primary' : '')}>*/}
                {/*    {t('home')}*/}
                {/*</Link>*/}
                {/*<Link to={"/rp"}*/}
                {/*      className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/') ? ' text-primary' : '')}>*/}
                {/*    {t('report')}*/}
                {/*</Link>*/}
                {/*{*/}
                {/*    (!isAdminMenu && isInstAdmin) ? <Button onClick={() => {onAdminMenuToggle(); navigate('/admin');}} className={"text-sm text-muted-foreground transition-colors hover:text-primary"}>*/}
                {/*        {t('gotoadmin')}*/}
                {/*    </Button> : <Button onClick={() => {onAdminMenuToggle(); navigate('/si');}} className={"text-sm text-muted-foreground transition-colors hover:text-primary"}>*/}
                {/*        {t('gotosimulate')}*/}
                {/*    </Button>*/}
                {/*}*/}

                {/*TODO:: checkit*/}
                {/*{*/}
                {/*    auth.user.isadmin === 1 && (*/}
                {/*        <Dropdown*/}
                {/*            menu={{*/}
                {/*                items: adminMenuItems,*/}
                {/*            }}*/}
                {/*            className={"flex item-center items-center text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/admin/global') ? ' text-primary' : '')}*/}
                {/*        >*/}
                {/*            <a onClick={(e) => e.preventDefault()}>*/}
                {/*                {t('admin')}*/}
                {/*                <Icon name={'ChevronDown'}/>*/}
                {/*            </a>*/}
                {/*        </Dropdown>*/}
                {/*    )*/}
                {/*}*/}
                {/*{*/}
                {/*    auth.user.isadmin === 1 && (*/}
                {/*        <Link to={"/pf"}*/}
                {/*              className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/admin/inst') ? ' text-primary' : '')}>*/}
                {/*            {t('Flow control')}*/}
                {/*        </Link>*/}
                {/*    )*/}
                {/*}*/}
                {/*{*/}
                {/*    auth.user.isadmin === 1 && (*/}
                {/*        <Link to={"/pf/customComponent"}*/}
                {/*              className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/admin/inst') ? ' text-primary' : '')}>*/}
                {/*            {t('complist')}*/}
                {/*        </Link>*/}
                {/*    )*/}
                {/*}*/}
                {/*{*/}
                {/*    auth.user.isadmin === 1 && (*/}
                {/*        <Link to={"/pf/itemtype"}*/}
                {/*              className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/admin/inst') ? ' text-primary' : '')}>*/}
                {/*            {t('Item types')}*/}
                {/*        </Link>*/}
                {/*    )*/}
                {/*}*/}
                {/*{*/}
                {/*    auth.user.isadmin === 1 && (*/}
                {/*        <Dropdown*/}
                {/*            menu={{*/}
                {/*                items: globalAdminMenuItems,*/}
                {/*            }}*/}
                {/*            className={"flex item-center items-center text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/admin/global') ? ' text-primary' : '')}*/}
                {/*        >*/}
                {/*            <a onClick={(e) => e.preventDefault()}>*/}
                {/*                    {t('globaladmin')}*/}
                {/*                    <Icon name={'ChevronDown'}/>*/}
                {/*            </a>*/}
                {/*        </Dropdown>*/}
                {/*    )*/}
                {/*}*/}
                {/*<Link to={"/ui-settings"}*/}
                {/*      className={"text-sm text-muted-foreground transition-colors hover:text-primary " + (isActive('/ui-settings') ? ' text-primary' : '')}>*/}
                {/*    {t('settings')}*/}
                {/*</Link>*/}
            </nav>
        </>

    );
}
